import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const getAnalyticsSummary = async () => {
  const response = await request(getEndpoint("analytics", "getSummary"));
  return response.data || {};
};
